//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ReviewCard',
  props: {
    review: { type: Object, required: true },
    showProductImage: { type: Boolean, default: true },
    linkProductImage: { type: Boolean, default: true },
    isOnProductPage: { type: Boolean, default: false },
    short: { type: Boolean, default: false }
  },
  computed: {
    product () {
      return this.review.items[0]
    },
    baseSku () {
      return this.$store.getters['product/baseSKU'](
        (this.product || '').split('-')[0]
      )
    },
    title () {
      if (this.review.review_title.startsWith('B64:')) {
        return this.b64DecodeUnicode(this.review.review_title.split(':')[1])
      }
      return this.review.review_title
    },
    body () {
      if (this.review.review_body.startsWith('B64:')) {
        return this.b64DecodeUnicode(this.review.review_body.split(':')[1])
      }
      return this.review.review_body
    },
    reply () {
      return this.review.reply
    }
  },
  methods: {
    handleClick (product) {
      return this.$emit('click', product)
    }
  }
}
